var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mxr-cta-email"}},[_c('a',{attrs:{"target":"_top","href":_vm.mailto},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }